import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Sheet, Button, Icon, List, ListItem, Typography } from '@sm/wds-react';
import classNames from 'classnames';
import { t, defineMessages } from '@sm/intl';
import SMHeaderContext from '../../SMHeaderContext';
import {
  getProductsItems,
  getProductsfootnote,
  getResourcesItems,
} from './getDrawerData';

import './drawer.scss';

const COPY = defineMessages({
  PRODUCTS: {
    id: 'Drawer.products',
    defaultMessage: 'Products',
    description:
      '[Type: Label][Vis.: high] - This is the Products title of the side menu.',
  },
  HELP: {
    id: 'Drawer.help',
    defaultMessage: 'Help',
    description:
      '[Type: Label][Vis.: high] - This is the Help title of the side menu.',
  },
});

export default class Drawer extends Component {
  toggleDrawer = () => {
    this.props.parentToggleDrawer(this.props.drawerKey);
  };

  static contextType = SMHeaderContext;

  render() {
    const { isDrawerOpen, drawerKey } = this.props;

    const { lang, isEUDC } = this.context;

    const arrowClass = classNames('sm-drawer__icon-caret', {
      open: isDrawerOpen,
    });

    const buttonClass = classNames(
      'sm-drawer__trigger',
      `sm-drawer__${drawerKey.toLowerCase()}-cta`
    );

    const ItemsData =
      drawerKey === 'Products'
        ? getProductsItems(lang, isEUDC)
        : getResourcesItems(lang);

    const NestedMenuItems = ItemsData.map(
      ({ title, url, subTitle, openInNewWindow = false }) => {
        return (
          <ListItem
            key={title}
            className="sm-drawer__anchor"
            isNavigable
            navigationTarget={url}
            {...(openInNewWindow === true && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
          >
            <Typography
              variant="cardTitle"
              color="dark"
              className="sm-drawer__product-title"
            >
              {title}
            </Typography>
            <Typography
              variant="bodySm"
              className="sm-drawer__product-subtitle"
              color="dark"
            >
              {subTitle}
            </Typography>
          </ListItem>
        );
      }
    );

    return (
      <>
        <Button
          variant="text"
          size="sm"
          className={buttonClass}
          onClick={this.toggleDrawer}
        >
          <div>
            <Icon>{drawerKey === 'Products' ? '·' : '?'}</Icon>
            <If condition={isDrawerOpen}>
              <Icon size="md" className={arrowClass}>
                —
              </Icon>
            </If>
          </div>
        </Button>
        <Sheet
          show={isDrawerOpen}
          onClose={this.toggleDrawer}
          placement="right"
          offsetTop={50}
        >
          <>
            <Typography
              className="sm-drawer sm-drawer__title"
              variant="sectionTitle"
              color="dark"
            >
              {drawerKey === 'Products' ? t(COPY.PRODUCTS) : t(COPY.HELP)}
            </Typography>
            <List className="sm-drawer" noRules>
              {NestedMenuItems}
            </List>
            {drawerKey === 'Products' && (
              <Typography
                variant="bodySm"
                className="sm-drawer sm-drawer__product-footnote"
                color="dark"
              >
                <em>{getProductsfootnote()}</em>
              </Typography>
            )}
          </>
        </Sheet>
      </>
    );
  }
}

Drawer.propTypes = {
  drawerKey: PropTypes.oneOf(['Products', 'Help']),
  isDrawerOpen: PropTypes.bool,
  parentToggleDrawer: PropTypes.func.isRequired,
};

Drawer.defaultProps = {
  drawerKey: 'Products',
  isDrawerOpen: false,
};
